import request from '@/utils/request'

/*
 * 用户相关
 */
export const login = (params) => {
  return request('user/login', params, 'post')
}
export const signLogin = (params) => {
  return request('user/signLogin', params, 'post')
}
export const logout = (params) => {
  return request('user/logout', params, 'post')
}
export const userSetting = (params) => {
  return request('user/userSetting', params, 'post')
}
export const staffStatus = (params) => {
  return request('user/staffStatus', params, 'post')
}
export const getStaffStatus = (params) => {
  return request('user/staffStatus', params, 'get')
}